export const DEVICE_COLUMN_TYPES = ["string", "int", "file"];
export const DEVICE_TYPE_STATUSES = ["active", "deprecated"];

export const DEVICE_TYPE_FORM_EMPTY = {
  name: "",
  manufacturer: "",
  protocol: "",
  status: "active",
  columns: [],
};

export function deviceTypeToForm(deviceType) {
  if (!deviceType) return { ...DEVICE_TYPE_FORM_EMPTY, columns: [] };
  return {
    name: deviceType.name ?? "",
    manufacturer: deviceType.manufacturer ?? "",
    protocol: deviceType.protocol ?? "",
    status: DEVICE_TYPE_STATUSES.includes(deviceType.status) ? deviceType.status : "active",
    columns: (deviceType.columns ?? []).map((col) => ({ key: col.key ?? "", type: col.type ?? "string" })),
  };
}

export function validateDeviceTypeForm(form) {
  const errors = {};
  if (!form.name?.trim()) errors.name = "Device type name is required";
  if (!form.manufacturer?.trim()) errors.manufacturer = "Manufacturer is required";
  if (!form.protocol?.trim()) errors.protocol = "Protocol is required";
  if (!DEVICE_TYPE_STATUSES.includes(form.status)) errors.status = "Select a status";

  const columnErrors = [];
  const seenKeys = new Set();
  (form.columns ?? []).forEach((col, index) => {
    const key = col.key?.trim();
    const row = {};
    if (!key) row.key = "Key is required";
    else if (seenKeys.has(key.toLowerCase())) row.key = "Duplicate key";
    else seenKeys.add(key.toLowerCase());
    if (!DEVICE_COLUMN_TYPES.includes(col.type)) row.type = "Select a type";
    if (Object.keys(row).length) columnErrors[index] = row;
  });
  if (columnErrors.some(Boolean)) errors.columns = columnErrors;

  return errors;
}

export function deviceTypeFormToPayload(form) {
  return {
    name: form.name.trim(),
    manufacturer: form.manufacturer.trim(),
    protocol: form.protocol.trim(),
    status: form.status,
    columns: (form.columns ?? [])
      .map((col) => ({ key: col.key.trim(), type: col.type }))
      .filter((col) => col.key),
  };
}
